import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Product/ImageViewer/imageViewer.container"
    ).then((module) => ({
        default: module.ImageViewerContainer
    }))
);
